import { DesktopSectionStyles } from '../../styles/styles';

type Prop = {
  desktopImgSrc: string[];
};

const DesktopSection = (props: Prop) => {
  const { desktopImgSrc } = props;
  const mobile = window.innerWidth < 500 ? true : false;

  return (
    <DesktopSectionStyles data-scroll-section>
      <div
        data-scroll
        data-scroll-speed={mobile ? '1' : '0.5'}
        className="main">
        <img src={desktopImgSrc[0]} alt="" />
      </div>
      <div data-scroll data-scroll-speed={mobile ? '1' : '4'} className="side">
        <img src={desktopImgSrc[1]} alt="" />
      </div>
    </DesktopSectionStyles>
  );
};

export default DesktopSection;
